var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M81.68 32.74h39.64v4.037H81.68zm0 5.787h39.64V64.25H81.68zm41.319-6.697c-.023-.463-.39-.83-.839-.83H80.84c-.45 0-.816.367-.839.83l-.001.045v33.25c0 .483.376.875.84.875h41.32c.464 0 .84-.392.84-.876V31.875l-.001-.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M104.2 35h-6.4c-.442 0-.8-.224-.8-.5s.358-.5.8-.5h6.4c.442 0 .8.224.8.5s-.358.5-.8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M101.5 35a.5.5 0 0 1 0-1 .5.5 0 1 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M112.832 59.257a11.857 11.857 0 0 0-2.77-6.86l3.164-3.272c2.463 2.806 3.89 6.347 4.08 10.131zM101.5 48.363c-2.653 0-5.185.944-7.214 2.677l-3.164-3.277c2.88-2.598 6.532-4.02 10.378-4.02 3.92 0 7.625 1.469 10.526 4.154l.001.001-3.161 3.273c-2.053-1.817-4.638-2.808-7.366-2.808zM90.178 59.267h-4.473c.193-3.862 1.667-7.463 4.213-10.293l3.16 3.273a11.847 11.847 0 0 0-2.9 7.02zm23.679-11.975l-.03-.032c-3.3-3.392-7.677-5.26-12.327-5.26-4.57 0-8.896 1.815-12.177 5.11-.012.01-.022.02-.032.032C85.88 50.582 84 55.192 84 60.128c0 .481.377.872.841.872h6.142c.464 0 .842-.39.842-.872 0-2.77 1.067-5.35 3.006-7.26 1.805-1.782 4.174-2.763 6.669-2.763 2.563 0 4.978 1.028 6.8 2.893 1.854 1.898 2.875 4.43 2.875 7.13 0 .481.377.872.842.872h6.142c.464 0 .841-.39.841-.872 0-4.853-1.827-9.41-5.143-12.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M104.079 61a.918.918 0 0 1-.651-.27l-5.158-5.158a.92.92 0 1 1 1.302-1.302l5.158 5.157A.92.92 0 0 1 104.08 61z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.6fb614a8.svg";
export { ForwardRef as ReactComponent };